import type { IconSvgObject } from './types';

const ArrowUpRight03Icon: IconSvgObject = [
  ["path", { d: "M17.5 6.5L6 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6H18V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUpRight03Icon;
